/** Runtime settings. In the container /config.js is written at start from environment variables, so one
 *  image works everywhere; nothing here is baked into the bundle. */
export interface SpurtConfig {
  /** Base URL of the Spurt chat service, e.g. "https://spurt.cilpron.com". Empty = same origin as the page. */
  apiUrl: string;
  appName: string;
}

declare global {
  interface Window {
    __SPURT__?: Partial<SpurtConfig>;
  }
}

const DEFAULTS: SpurtConfig = {
  // set VITE_SPURT_URL in the suite's .env, or window.__SPURT__ = { apiUrl } before the app starts
  apiUrl: (import.meta.env?.VITE_SPURT_URL as string | undefined) ?? "",
  appName: "Spurt",
};

export const config = (): SpurtConfig => ({ ...DEFAULTS, ...(typeof window !== "undefined" ? window.__SPURT__ : undefined) });

const trimSlash = (u: string): string => u.replace(/\/+$/, "");

/** Where /api/... lives. */
export const apiBase = (): string => trimSlash(config().apiUrl);

/** The WebSocket endpoint: the chat service's host (or this page's, when apiUrl is empty). */
export const wsUrlFor = (override?: string): string => {
  if (override) return override;
  const base = apiBase();
  if (base) return base.replace(/^http/i, "ws") + "/ws";
  const { protocol, host } = window.location;
  return `${protocol === "https:" ? "wss:" : "ws:"}//${host}/ws`;
};
